import react, { useState, useEffect, use } from "react";
import roles from "./roles.json"; // see below for contents

const SelectRealRoleModal = (props) => {
    let theRoles = JSON.parse(JSON.stringify(roles));
    theRoles = theRoles.filter((role) => role.presumedGender == props.gender);
    const [filteredRealRoles, setFilteredRealRoles] = useState(theRoles);
    const [myRoles, setMyRoles] = useState(props.selectedRealRoles || []);

    const searchRealRoles = (searchTerm) => {
        const filtered = theRoles.filter((role) =>
            role.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredRealRoles(filtered);
    };

    const handleSelectRealRole = (role) => {
        if(props.selectedRealRoles.map(r => r.title).includes(role.title)) {
            props.removeRealRole(role);
            return;
        } else {
            props.addRealRole(role);
        }
    };

    useEffect(() => {
        setMyRoles(props.selectedRealRoles);
    }, [props.selectedRealRoles]);

    return (
        <div style={{ display: props?.show ? 'block' : 'none' }} className='select-archetype-modal-container'>
            <div className="select-archetype-modal-overlay" onClick={() => props?.setShow(false)}></div>
            <div className="select-archetype-modal">
                <div className="select-archetype-modal-header">
                    <button className="select-archetype-modal-close-button" onClick={() => props?.setShow(false)} style={{position: "absolute", top: "10px", right: "10px", background: "none", border: "none", cursor: "pointer"}}>❌</button>
                </div>
                <div className="select-archetype-modal-body">
                    <h2>Select Real Role(s)</h2>
                    {/* <input type="text" placeholder="Search Roles..." style={{width: "auto", padding: "8px", margin: "5px auto"}} onChange={(e) => searchRealRoles(e.target.value)} /> */}
                    <ul style={{listStyleType: "none", padding: 0, maxHeight: "300px", overflowY: "auto"}}>
                        {filteredRealRoles.map((role) => (
                            <li className={"role-item "+(myRoles.map(r => r.title).includes(role.title) ? "selected" : "")} key={role.title} style={{padding: "10px", borderBottom: "1px solid #ccc", cursor: "pointer"}} onClick={() => handleSelectRealRole(role)}>
                                {role.title}
                            </li>
                        ))}
                    </ul>
                    <button className="center-form-button" onClick={() => props?.setShow(false)} style={{marginTop: "10px", padding: "10px 20px", fontSize: "18px", cursor: "pointer"}}>
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SelectRealRoleModal;